class CustomerInfo {
  constructor() {
    this.init();
  }

  init() {
    this.handleUrlParams();
    this.initBirthdayDropdowns();
    this.handleFormSubmit();
  }

  handleUrlParams() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (!urlParams) return;

    const first_name = urlParams.get('first_name');
    const last_name = urlParams.get('last_name');
    const email = urlParams.get('email');
    const phone = urlParams.get('pn');
    const hidden = urlParams.get('cb');
    const email_permission = urlParams.get('can_email');

    if (first_name) {
      const firstNameEl = document.getElementById('first-name');
      if (firstNameEl) firstNameEl.value = first_name;
    }

    if (last_name) {
      const lastNameEl = document.getElementById('last-name');
      if (lastNameEl) lastNameEl.value = last_name;
    }

    if (email && email !== "") {
      const emailEl = document.getElementById('email');
      if (emailEl) {
        emailEl.value = email;
        emailEl.disabled = true;
      }
    }

    if (phone && phone !== "") {
      let pnWithPlus = phone;
      // In URL params "+"-sign gets turned into empty space
      if (phone.indexOf(" ") >= 0) {
        pnWithPlus = phone.replace(" ", "+");
      }

      const phoneEl = document.getElementById('phone');
      if (phoneEl) {
        phoneEl.value = pnWithPlus;
        phoneEl.disabled = true;
      }
    }

    if (hidden) {
      const hiddenTokenEl = document.getElementById('hiddenToken');
      if (hiddenTokenEl) hiddenTokenEl.value = hidden;
    }

    if (email_permission === "True" || email_permission === "true") {
      const emailMarketingEl = document.getElementById('emailMarketing');
      if (emailMarketingEl) emailMarketingEl.checked = true;
    }
  }

  initBirthdayDropdowns() {
    const yearSelect = document.getElementById("year");
    const monthSelect = document.getElementById("month");
    const daySelect = document.getElementById("day");

    if (!yearSelect || !monthSelect || !daySelect) return;

    const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    let previousDay;

    // Populate months
    months.forEach(month => {
      const option = document.createElement('option');
      option.textContent = month;
      monthSelect.appendChild(option);
    });
    monthSelect.value = "01";

    // Populate days based on month
    const populateDays = (month) => {
      // Delete all of the children of the day dropdown
      while (daySelect.firstChild) {
        daySelect.removeChild(daySelect.firstChild);
      }

      // Get the current year
      const year = yearSelect.value;
      let dayNum;

      if (month === '01' || month === '03' || month === '05' || month === '07' || 
          month === '08' || month === '10' || month === '12') {
        dayNum = 31;
      } else if (month === '04' || month === '06' || month === '09' || month === '11') {
        dayNum = 30;
      } else {
        // Check for a leap year
        if (new Date(year, 1, 29).getMonth() === 1) {
          dayNum = 29;
        } else {
          dayNum = 28;
        }
      }

      // Insert the correct days into the day <select>
      for (let i = 1; i <= dayNum; i++) {
        const option = document.createElement("option");
        option.textContent = i;
        daySelect.appendChild(option);
      }

      if (previousDay) {
        daySelect.value = previousDay;
        if (daySelect.value === "") {
          daySelect.value = previousDay - 1;
        }
        if (daySelect.value === "") {
          daySelect.value = previousDay - 2;
        }
        if (daySelect.value === "") {
          daySelect.value = previousDay - 3;
        }
      }
    };

    // Populate years
    const populateYears = () => {
      const year = new Date().getFullYear();
      // Make the previous 100 years be an option
      for (let i = 0; i < 101; i++) {
        const option = document.createElement("option");
        option.textContent = year - i;
        yearSelect.appendChild(option);
      }
    };

    // Format birthday to hidden field from separate fields
    const formatBirthday = () => {
      const birthdayEl = document.getElementById("birthday");
      if (!birthdayEl) return;

      const day = daySelect.value;
      const month = monthSelect.value;
      const year = yearSelect.value;

      if (day && month && year) {
        const dayFormatted = day.toString().length < 2 ? "0" + day : day;
        birthdayEl.value = `${year}-${month}-${dayFormatted}`;
      }
    };

    // Initialize
    populateDays(monthSelect.value);
    populateYears();

    // Event listeners
    yearSelect.addEventListener('change', () => {
      populateDays(monthSelect.value);
      formatBirthday();
    });

    monthSelect.addEventListener('change', () => {
      populateDays(monthSelect.value);
      formatBirthday();
    });

    daySelect.addEventListener('change', () => {
      previousDay = daySelect.value;
      formatBirthday();
    });
  }

  handleFormSubmit() {
    const form = document.getElementById('mailing-list-form');
    const feedbackEl = document.getElementById('mailing-list-feedback');

    if (!form) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      // Here you would typically submit to Custobar API
      // For now, just show the feedback message
      if (feedbackEl) {
        feedbackEl.style.display = 'block';
        form.style.display = 'none';
      }

      // Scroll to feedback message
      if (feedbackEl) {
        feedbackEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }
}

